import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for list usercontrol
export const AddUsageControl = createSlice({
  name: "AddUsageControl",
  initialState: {
    api_completed: false,
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    switchResponse: false,
    data: [],
  },
  reducers: {
    add_AddUsageControl: (state, _) => {
      state.isLoading = true;
    },
    success_api_call_add_AddUsageControl: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
      state.isFirst = true;
      state.switchResponse = true;
    },
    failure_api_call_add_AddUsageControl: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.api_completed = true;
      state.switchResponse = true; 
    },
    add_AddUsageControl_is_success: (state, action) => {
      state.isSuccess = false;
    },
    create_AddUsageControl_complete_api: (state, action) => {
      state.api_completed = false;
    },
    clear_AddUsageControl_Data: (state) => {
      state.data = [];
    },
    false_switchAddUsageControl_response: (state) => {
      state.switchResponse = false;
    },
  },
});
export default AddUsageControl.reducer;
export const {
  add_AddUsageControl,
  success_api_call_add_AddUsageControl,
  failure_api_call_add_AddUsageControl,
  create_AddUsageControl_complete_api,
  add_AddUsageControl_is_success,
  clear_AddUsageControl_Data,
  false_switchAddUsageControl_response
} = AddUsageControl.actions;
